const CryptoHelpers = {
    unsafeSimpleHash: (input: string = ''): string => {
        return (
            input.split('').reduce(function (a, b) {
                a = (a << 5) - a + b.charCodeAt(0);
                return a & a;
            }, 0) + ''
        );
    },
};

export { CryptoHelpers };
